document.addEventListener('DOMContentLoaded', function () {
  function parseMaxQty(value) {
    const max = parseInt(value, 10);
    return isNaN(max) ? null : max;
  }

  function getCartData() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json();
    });
  }

  function getExistingCartQty(cart, variantId) {
    if (!cart || !cart.items || !variantId) return 0;

    const match = cart.items.find(function (item) {
      return String(item.variant_id) === String(variantId);
    });

    return match ? parseInt(match.quantity, 10) || 0 : 0;
  }

  function showInlineMessage(targetId, message) {
    const el = targetId ? document.getElementById(targetId) : null;
    if (el) {
      el.textContent = message;
      el.style.display = 'block';
    } else {
      alert(message);
    }
  }

  function hideInlineMessage(targetId) {
    const el = targetId ? document.getElementById(targetId) : null;
    if (!el) return;
    el.textContent = '';
    el.style.display = 'none';
  }

  function bindProductPageLimit() {
    const forms = document.querySelectorAll('form[id^="product-form-"]');

    forms.forEach(function (form) {
      if (form.dataset.maxQtyBound === 'true') return;
      form.dataset.maxQtyBound = 'true';

      const qtyInput = document.querySelector(
        'input.quantity__input[name="quantity"][form="' + form.id + '"][data-max-qty]'
      );
      const variantInput = form.querySelector('input[name="id"]');
      const addButton = form.querySelector('button[name="add"]');

      if (!qtyInput || !variantInput || !addButton) return;

      const maxQty = parseMaxQty(qtyInput.getAttribute('data-max-qty'));
      if (!maxQty) return;

      const productTitle = qtyInput.getAttribute('data-product-title') || 'this product';
      const messageTarget = qtyInput.getAttribute('data-qty-message-target');
      const wrapper = qtyInput.closest('.quantity');
      const plusBtn = wrapper ? wrapper.querySelector('.quantity__button[name="plus"]') : null;
      const minusBtn = wrapper ? wrapper.querySelector('.quantity__button[name="minus"]') : null;

      function normalizeLocalValue() {
        let value = parseInt(qtyInput.value, 10);

        if (isNaN(value) || value < 1) value = 1;
        if (value > maxQty) value = maxQty;

        qtyInput.value = value;
        return value;
      }

      qtyInput.addEventListener('input', function () {
        const value = normalizeLocalValue();
        if (value >= maxQty) {
          showInlineMessage(messageTarget, `Maximum ${maxQty} units allowed for ${productTitle}.`);
        } else {
          hideInlineMessage(messageTarget);
        }
      });

      qtyInput.addEventListener('change', function () {
        const value = normalizeLocalValue();
        if (value >= maxQty) {
          showInlineMessage(messageTarget, `Maximum ${maxQty} units allowed for ${productTitle}.`);
        } else {
          hideInlineMessage(messageTarget);
        }
      });

      if (plusBtn) {
        plusBtn.addEventListener('click', function (e) {
          const current = parseInt(qtyInput.value, 10) || 1;
          if (current >= maxQty) {
            e.preventDefault();
            e.stopPropagation();
            qtyInput.value = maxQty;
            showInlineMessage(messageTarget, `Maximum ${maxQty} units allowed for ${productTitle}.`);
          } else {
            setTimeout(function () {
              normalizeLocalValue();
            }, 0);
          }
        });
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          setTimeout(function () {
            normalizeLocalValue();
          }, 0);
        });
      }

      addButton.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();

          const addQty = normalizeLocalValue();
          const variantId = variantInput.value;

          getCartData()
            .then(function (cart) {
              const existingQty = getExistingCartQty(cart, variantId);
              const totalQty = existingQty + addQty;

              if (totalQty > maxQty) {
                showInlineMessage(
                  messageTarget,
                  `You already have ${existingQty} in cart. Maximum ${maxQty} units allowed for ${productTitle}.`
                );
                return;
              }

              hideInlineMessage(messageTarget);

              const formData = new FormData(form);
              formData.set('quantity', addQty);

              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  Accept: 'application/json'
                },
                body: formData,
                credentials: 'same-origin'
              }).then(function (res) {
                if (!res.ok) throw new Error('Add to cart failed');
                return res.json();
              }).then(function () {
                window.location.reload();
              });
            })
            .catch(function (err) {
              console.error(err);
              showInlineMessage(messageTarget, `Could not add ${productTitle} to cart.`);
            });
        },
        true
      );
    });
  }

  function bindCartDrawerLimit() {
    const cartInputs = document.querySelectorAll('input.quantity__input[name="updates[]"][data-cart-max-qty]');

    cartInputs.forEach(function (input) {
      if (input.dataset.cartQtyBound === 'true') return;
      input.dataset.cartQtyBound = 'true';

      const maxQty = parseMaxQty(input.getAttribute('data-cart-max-qty'));
      if (!maxQty) return;

      const productTitle = input.getAttribute('data-product-title') || 'this product';
      const wrapper = input.closest('.quantity');
      const plusBtn = wrapper ? wrapper.querySelector('.quantity__button[name="plus"]') : null;
      const minusBtn = wrapper ? wrapper.querySelector('.quantity__button[name="minus"]') : null;

      function normalizeValue(showAlert) {
        let value = parseInt(input.value, 10);

        if (isNaN(value) || value < 0) value = 0;

        if (value > maxQty) {
          input.value = maxQty;
          if (showAlert) alert(`Maximum ${maxQty} units allowed for ${productTitle}.`);
          return false;
        }

        input.value = value;
        return true;
      }

      input.addEventListener('input', function () {
        normalizeValue(false);
      });

      input.addEventListener('change', function () {
        normalizeValue(true);
      });

      if (plusBtn) {
        plusBtn.addEventListener('click', function (e) {
          const current = parseInt(input.value, 10) || 0;
          if (current >= maxQty) {
            e.preventDefault();
            e.stopPropagation();
            input.value = maxQty;
            alert(`Maximum ${maxQty} units allowed for ${productTitle}.`);
          } else {
            setTimeout(function () {
              normalizeValue(false);
            }, 0);
          }
        });
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          setTimeout(function () {
            normalizeValue(false);
          }, 0);
        });
      }
    });
  }

  function initQuantityLimits() {
    bindProductPageLimit();
    bindCartDrawerLimit();
  }

  initQuantityLimits();
  document.addEventListener('shopify:section:load', initQuantityLimits);
});